/**
 * Try to parse a Response body as JSON. Returns null on failure (e.g. HTML 502
 * body) so the caller can fall back to an HTTP-status message.
 */
export const safeJson = async (response: Response): Promise<unknown> => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

/**
 * Extract a string error message from a parsed JSON body.
 * Accepts: { error: '...' }, { message: '...' }, { errors: [{ msg: '...' }] }
 */
export const extractError = (data: unknown, fallback: string): string => {
  if (!data || typeof data !== 'object') return fallback;
  const d = data as Record<string, unknown>;
  if (typeof d.error === 'string' && d.error) return d.error;
  if (typeof d.message === 'string' && d.message) return d.message;
  if (Array.isArray(d.errors) && d.errors.length > 0) {
    const first = d.errors[0];
    if (first && typeof first === 'object') {
      const msg = (first as Record<string, unknown>).msg;
      if (typeof msg === 'string' && msg) return msg;
    }
  }
  return fallback;
};
